<template>
  <div class="auth-code-box show-flex-box-r">
    <dl class="show-flex-box-r">
      <dt><input type="text" placeholder="验证码" autocomplete="off" @input="controlCode" v-model="authCode" maxlength="4"></dt>
      <dd>
        <strong v-if="isSendStatus" @click="sendCode">获取验证码</strong>
        <span v-else >{{countDown}}s后重新发送</span>
      </dd>
    </dl>
  </div>
</template>

<script>
import regex from '@/filter/regex'

export default {
  /*
   * 所需参数：
   * 1、:codeType(发送验证码类型)-- 
   *      'login':短信登录;
   *      'register':注册;
   *      'forgetPwd':忘记密码';
   *      'appointment': 预约课程
   * 2、:phoneNum(发送验证码手机号)
   * 
   * 功能：
   *  获取掩码码方法：@inputCode--获取到输入的验证码
   *  父级清空验证码信息：this.$refs.authCodeObj.clearAuthCode();
   * 
   */

  name: 'send_authcode_cpn',
  props: {
    phoneNum: [String,Number],
    codeType: [String]
  },
  data () {
    return {
      authCode: '',
      isSendStatus: true,
      countDown: 59
    }
  },
  methods: {
    // 清空验证码
    clearAuthCode: function() {
      this.authCode = '';
      this.isSendStatus = true;
    },
    // 控制显示4位验证码
    controlCode: function() {
      this.authCode = this.authCode.slice(0,4);
    },
    // 设置发送显示状态
    setSendStatus: function() {
      this.isSendStatus = !this.isSendStatus;
    },
    // 父级获取到验证码
    inputCode: function() {
      this.$emit('inputCode',this.authCode);
    },
    setCountDown: function(count) {
      let vSelf = this;
      if (count >= 0) {
        setTimeout(function() {
          vSelf.countDown = count;
          vSelf.setCountDown(count - 1);
        },1000)
      } else {
        vSelf.countDown = 59;
        vSelf.setSendStatus();
      }
    },
    // 根据不同类型发送验证码
    sendCode: function() {
      let sendType = this.codeType;

      if (regex.isEmpty(this.phoneNum)) {
        this.$elementMsg.error({
          'message': '手机号不能为空',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
         })
        return;
      }

      let phoneObj = {
        'type': sendType,
        'phone': this.phoneNum
      }

      if (sendType === 'login') {
        this.sendCodeWithLogin(phoneObj);
      } else if (sendType === 'reg') {
        this.sendCodeWithRegister(phoneObj);
      } else if (sendType === 'find_pwd') {
        this.sendCodeWithForgetPwd(phoneObj);
      }
    },
    // 发送登录验证码
    sendCodeWithLogin: function(phoneObj) {
      let vSelf = this;

      this.$client.sendLoginCode(phoneObj)
        .then((resp) => {
          if (resp.code == 200 || resp.code == '200') {
            vSelf.setCountDown(this.countDown);
            vSelf.setSendStatus();
          }
        }).catch((err) => {
  
        })
      
    },
    // 发送注册验证码
    sendCodeWithRegister: function(phoneObj) {
      let vSelf = this;

      this.$client.sendRegisterCode(phoneObj)
        .then((resp) => {
          if (resp.code == 200 || resp.code == '200') {
            vSelf.setCountDown(this.countDown);
            vSelf.setSendStatus();
          }
        }).catch((err) => {

        })
    },
    // 发送忘记密码验证码
    sendCodeWithForgetPwd: function(phoneObj) {
      let vSelf = this;

      this.$client.sendFoundPwdCode(phoneObj)
        .then((resp) => {
          if (resp.code == 200 || resp.code == '200') {
            vSelf.setCountDown(this.countDown);
            vSelf.setSendStatus();
          }
        }).catch((err) => {
        })
    },
    // 发送预约课程验证码
    sendCodewithAppointment: function(phoneObj) {
      let vSelf = this;

      this.$client.sendAppointment(phoneObj)
        .then((resp) => {
          if (resp.code == 200 || resp.code == '200') {
            vSelf.setCountDown(this.countDown);
            vSelf.setSendStatus();
          }
        }).catch((err) => {

        })
    }
  },
  watch: {
    authCode: function() {
      this.inputCode();
    }
  }
}
</script>

<style lang="less" scoped>
  .auth-code-box {
    width: 100%;
    &>dl {
      flex-grow: 1;
      align-items: center;
      background: #FAFAFA;
      border: 1px solid #E5E5E5;
      border-radius: 5px;
      &>dt {
        flex-grow: 1;
        width: 0;
        &>input {
          flex-shrink: 0;
          display: block;
          background: none;
          border: none;
          height: 38px;
          font-size: 18px;
          line-height: normal;
          padding-left: 14px;
          color: #191D21;
          border-radius: 5px;
        }
      }
      &>dd {
        min-width: 30px;
        height: 20px;
        padding-left: 10px;
        padding-right: 10px;
        border-left: 1px solid #E5E5E5;
        &>strong {
          display: block;
          font-size: 16px;
          line-height: 20px;
          color: #FF7800;
          cursor: pointer;
        }
        &>span {
          font-size: 16px;
          color: #7F7F7F;
          line-height: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/send_authcode_cpn.vue